import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const listTagRefs = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/tagRef`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
        data: filter,
    });
    return res;
};

export const getTagRef = async (tagRefId) => {
    let res = {},
        searchEndpoint = '/v2/tag';

    if (tagRefId !== '0') {
        res =
            (await r({
                endpoint: `${keeper('apiUrl')}/v2/tagRef/${tagRefId}`,
                sessionToken: keeper('sessionToken'),
                method: 'get',
            })) || {};
    }

    if (Object.keys(res).length === 0) {
        res = await normalizeBySchema(searchEndpoint, 'post', res);
    }

    return res;
};

export const createTagRef = async (tagId, templateId) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/tagRef`,
        sessionToken: keeper('sessionToken'),
        method: 'post',
        data: {
            tagId: tagId,
            templateId: templateId,
        },
    });

    return res;
};

export const deleteTagRef = async (tagRefId) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/tagRef/${tagRefId}`,
        sessionToken: keeper('sessionToken'),
        method: 'delete',
    });

    return res;
};

export const deleteTagRefsByTagId = async (tagRed) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/tagRef/tag/${tagRed}`,
        sessionToken: keeper('sessionToken'),
        method: 'delete',
    });

    return res;
};

export const useTagRefs = () => {
    return {
        listTagRefs: listTagRefs,
        getTagRef: getTagRef,
        createTagRef: createTagRef,
        deleteTagRef: deleteTagRef,
        deleteTagRefsByTagId: deleteTagRefsByTagId,
    };
};

export default useTagRefs;
